// Vendor Libs
import 'react-hot-loader';
import React from 'react';
import {render} from 'react-dom';

// Base Styles
import './styles/foundation/foundation.css';
import 'primeflex/primeflex.css';

// Components
import App from './app';

render(<App />, document.getElementById('app'));
